module.exports = __webpack_public_path__ + "static/home-slider2-b6ab87178e56777ef4a3182f517be864.jpeg";